import React, { createContext, useContext, useMemo } from 'react';
const SelectContext = createContext(undefined);
export const SelectProvider = ({ open, invalid, disabled, children }) => {
    const value = useMemo(() => ({
        open,
        invalid,
        disabled,
    }), [open, invalid, disabled]);
    return (React.createElement(SelectContext.Provider, { value: value }, children));
};
export const useSelect = () => {
    const context = useContext(SelectContext);
    if (context === undefined) {
        throw new Error('useSelect must be used within a SelectProvider');
    }
    return context;
};
//# sourceMappingURL=SelectContext.js.map